var React = require('react');

function Inbox (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.89.563L.005 8.018 0 12.118c0 .486.393.881.88.882h14.238a.882.882 0 0 0 .882-.882V8.037L13.112.564A.882.882 0 0 0 12.289 0H3.712a.882.882 0 0 0-.822.563zM4.008 2.06h7.982l1.626 5.124h-1.562a.882.882 0 0 0-.881.882v2.253H4.828V8.066a.882.882 0 0 0-.881-.882H2.38L4.008 2.06z","fill":"currentColor","fillRule":"evenodd"}));
}

Inbox.defaultProps = {"width":"16","height":"13","viewBox":"0 0 16 13"};

module.exports = Inbox;

Inbox.default = Inbox;
